import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { omit, cloneDeep, isFunction } from 'lodash';
export { cloneDeep, curry, debounce, differenceBy, differenceWith, filter, findIndex, get, groupBy, isBoolean, isEmpty, isEqual, isEqualWith, isFunction, isNaN, isObject, isString, maxBy, meanBy, noop, omit, orderBy, padStart, parseInt, pick, pickBy, property, pull, range, set, sortBy, sumBy, throttle, transform, uniq, uniqBy, values } from 'lodash';
export { compose } from './compose.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Concatenates classNames from arguments
 *
 * @param {...any} classnames
 */

var cx = function cx() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.reduce(function (result, cn) {
    return "".concat(result, " ").concat(cn || '');
  }, '');
}; // if entry exists, remove it, if not, add it

var toggleInObject = function toggleInObject(obj, key, value) {
  return obj[key] !== undefined ? omit(obj, [key]) : _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, value));
};

var toggleInArray = function toggleInArray(array, value) {
  return array.indexOf(value) === -1 ? [value] : [];
};

var arrayMoveMutate = function arrayMoveMutate(array, from, to) {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

var arrayMove = function arrayMove(array, from, to) {
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
};

var accessorDefault = function accessorDefault(item) {
  return item;
};

var addOrRemove = function addOrRemove(array, item) {
  var accessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : accessorDefault;
  var index = array.findIndex(function (iItem) {
    return accessor(iItem) === accessor(item);
  });

  if (index !== -1) {
    var nextArray = cloneDeep(array);
    nextArray.splice(index, 1);
    return nextArray;
  }

  return [].concat(_toConsumableArray(array), [item]);
};

function runAll() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return fns.forEach(function (fn) {
      if (Array.isArray(fn)) runAll(fn);
      if (isFunction(fn)) fn.apply(void 0, args);
    });
  };
}
function hashArray(arr, fieldName) {
  return arr.reduce(function (result, item) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, fieldName ? item[fieldName] : item, true));
  }, {});
}
function safeCall(fun) {
  if (isFunction(fun)) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    fun.apply(void 0, args);
  }
}
var removeUndefinedProperties = function removeUndefinedProperties(obj) {
  var cleanObject = _objectSpread({}, obj);

  Object.keys(obj).forEach(function (key) {
    return cleanObject[key] === undefined && delete cleanObject[key];
  });
  return cleanObject;
};
var utils = {};

export default utils;
export { addOrRemove, arrayMove, cx, hashArray, removeUndefinedProperties, runAll, safeCall, toggleInArray, toggleInObject };
//# sourceMappingURL=utils.js.map
